import { useLocation } from "react-router-dom";
import { useRef } from "react";
import ModalComponents from "../components/modals/ModalComponents";
import { toast } from "react-toastify";

const PrivateRoute = ({ children, setEnteredUser, setIsModalOpen }: any) => {
  const location = useLocation();
  const accessToken = localStorage.getItem("access_token");
  const hasShownToast = useRef(false); // Track if the toast has been shown

  if (!accessToken) {
    setIsModalOpen(true); // Open the modal
    if (!hasShownToast.current) {
      toast.warning("جهت مشاهده اطلاعات میبایست ابتدا وارد پنل خود شوید");
      hasShownToast.current = true; // Mark toast as shown
    }
    return (
      <>
        <div className="flex pt-[10vh] justify-center bg-primary-100 w-full h-full mx-auto"></div>
        <ModalComponents
          setEnteredUser={setEnteredUser}
          onClose={() => setIsModalOpen(false)}
          navigateHere={location.pathname} // Save the requested path
        />
      </>
    );
  }

  hasShownToast.current = false; // Reset when accessToken is available
  return children; // Render the protected component
};

export default PrivateRoute;
